import { getMeeznaFormUrl } from "./apiServices";

export const BASE_URL = window.BASE_URL;
export const API_TOKEN = window.API_TOKEN;

export const apis = {
  BASE_URL,
  API_TOKEN,
  // User
  userLogin: "/api/passengersapi/login",
  userSignUp: "/api/passengersapi",
  verifyOtp: "/api/passengersapi/verifyotp",
  genrateOtp: "/api/passengersapi/genrateotp",
  forgotPassword: "/api/passengersapi/forgotten",
  resetPassword: (user_id) => `/api/passengersapi/${user_id}/forgottenpassword`,
  contactUs: "/api/contact_numbers/all",
  faqs: "/api/faqs",
  updateProfile: (passengerId) =>
    `api/passengersapi/${passengerId}/updateProfile`,
  updatepassword: (passengerId) =>
    `api/passengersapi/${passengerId}/updatePassword`,
  deleteAccount: (id) => `api/passengersapi/${id}/delete`,
  reservationsRoute: (user_id) => `/api/reservationsroute/${user_id}`,

  // Routes
  getAllRoutes: "/api/assignroutequeueapi",
  getStops: (route_id) => `api/vehiclesrouteapi/${route_id}`,

  // Wallet
  getTransactions: (userId) => `api/transactions/${userId}`,
  generateTopupInvoice: "api/invoices/generate",
  applyCoupon: "api/transactions/coupon",
  getOnlinePaymentAccounts: "api/bank_accounts",

  // Reserve Seat
  createReservation: "api/reservations/reserve",
  getBalance: (userId) => `api/transactions/balance/${userId}`,
  getFare: (routeId, pickupStopId, dropoffStopId) =>
    `api/settings/fare/${routeId}/${pickupStopId}/${dropoffStopId}`,
  cancelReservation: (reservationId) =>
    `api/reservations/cancel/${reservationId}`,

  // Feedback
  submitFeedback: "/api/complaintapi",
  getAllFeedbacks: (user_id) => `api/complaintapi/${user_id}/feedback`,
  getThread: (id) => `api/complaintapi/${id}`,
  getThreadInfo: (type_id) => `api/complaintapi/${type_id}/complainttype`,
  registerComplaint: "/api/complaintapi",

  //Meezan
  getMeeznaFormUrl: "/api/payments/meezan/form",

  //Subscriptions
  getSubscriptions: (userId) => `api/reservationsroute/${userId}/subscriptions`,
  renewSubscription: (subscriptionId) =>
    `api/reservationsroute/subscriptions/${subscriptionId}/renew`,

  //Reservation Templates
  reservationTemplates: (completeRouteId) =>
    `api/templates/all/route/${completeRouteId}`,
};
